import { useEffect, useState } from "react";
import ApiStatus from "../../components/ApiStatus";
import Heading from "../../components/Common/Heading"
import Section from "../../components/Common/Section"
import CardGroup from "../../components/Common/CardGroup"
import Card from "../../components/Common/Card"
import CardOverview from "../../components/Common/CardOverview";
import TabMenu from "../../components/Navigation/TabMenu"
import TabItem from "../../components/Navigation/TabItem"
import { formatDate } from "../../utils/DateFormatter";
import { IzobrazevanjePrijavaUporabnikGroupedType, useFetchUporabnikAktualno, useFetchUporabnikMojePrijave } from "./IzobrazevanjePrijavaHooks";
import { IzobrazevanjePrijavaListDto } from "../../types/IzobrazevanjePrijava/IzobrazevanjePrijavaListDto";
import { useNavigate } from "react-router-dom";
import Nullable from "../../types/Nullable";
import { format } from "date-fns";
import styled from "styled-components";
import IzobrazevanjeListGroupFilter from "../izobrazevanje/IzobrazevanjeListGroupFilter";
import ThumbnailDescriptionCard from "../../components/Common/ThumbnailDescriptionCard";
import { getPathWithBaseURL } from "../../utils/Common";

const StyledIzobrazevanjePregledDiv = styled.div`
    display: flex;
    flex-direction: row;
    gap:95px;
    max-width:1400px;

    .izobrazevanjePregled{
        flex-grow:5;
        flex-basis: 0;
    }

    .izobrazevanjePregled .cards{
        flex-direction:column;
    }

    .izobrazevanjePregled .card{
        width:auto;
        margin-right:0;
    }

    .izobrazevanjePregled .card .middle{
        padding-right:0.4rem;
        justify-content: start;
    }
    
    .izobrazevanjePregled .card .middle p{
        max-height: 65px;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .izobrazevanjeCategoryBox{
        flex-grow:2;
        flex-shrink:0;
        margin-top:60px;
        flex-basis: 0;
    }

     @media (max-width: 900px){
        flex-direction: column;
        gap:0;

        .izobrazevanjeCategoryBox{
            order:1;
            margin-top:0;
        }

        .izobrazevanjePregled{
            order:2;
        }
    }
`

interface AktualnoTabArgs {
    handleItemClick: (izobrazevanjeId: number) => void
}

const AktualnoTab = ({ handleItemClick }: AktualnoTabArgs) => {
    const { data, status, isSuccess } = useFetchUporabnikAktualno();
    const [selectedGroups, setSelectedGroups] = useState<string[]>([]);

    useEffect(() => {
        console.log("AktualnoTab - data", data);
        if (data) {
            setSelectedGroups(Object.keys(data));
        }
    }, [data]);

    const handleGroupChange = (groups: string[]) => {
        setSelectedGroups(groups);
    };

    if (!isSuccess)
        return <ApiStatus status={status}></ApiStatus>

    return (

        <>

            <Heading>
                <p>
                    Za vašo organizacijo so trenutno na voljo naslednja izobraževanja:
                </p>
            </Heading>
            <StyledIzobrazevanjePregledDiv>
                <div className="izobrazevanjePregled">
                    {selectedGroups && selectedGroups.map((key) => (
                        <CardGroup key={key} title={`${key}`}>
                            {
                                (data[key] as []).map((izobrazevanje: IzobrazevanjePrijavaListDto) => (
                                    <ThumbnailDescriptionCard
                                        key={`${izobrazevanje.izobrazevanjeId}`}
                                        onClick={() => { handleItemClick(izobrazevanje.izobrazevanjeId) }}
                                        color='#397289'
                                        icon="school"
                                        title={`${izobrazevanje.naziv}`}
                                        fromDate={format(new Date(izobrazevanje.datumCasOd), 'dd.MM.yyyy')}
                                        toDate={format(new Date(izobrazevanje.datumCasDo), 'dd.MM.yyyy')}
                                        showProstaMestaLabel={true}
                                        steviloProstihMest={izobrazevanje.steviloProstihMest}
                                        prijavaOmejena={izobrazevanje.prijavaOmejena}
                                        stTock={izobrazevanje.tockeSt}
                                        thumbnail={izobrazevanje.thumbnail ? getPathWithBaseURL(izobrazevanje.thumbnail) : null }
                                        description={izobrazevanje.opis}
                                        mentor={izobrazevanje.mentorImePriimek} />
                                ))}
                        </CardGroup>
                    ))}
                </div>
                <div className="izobrazevanjeCategoryBox">
                    {
                        <IzobrazevanjeListGroupFilter groups={Object.keys(data).sort()} headerText="Izberite kategorije:" onGroupChange={handleGroupChange} />
                    }
                </div>
            </StyledIzobrazevanjePregledDiv>
            
        </>

    );
}

export default AktualnoTab;
